import { Image } from 'expo-image';
import { StyleSheet } from 'react-native';
import { ImageVariant } from '@/components/Custom/Util.types';
import Box from '@/components/UI/Box';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';
import getCloudflareMediaUrl from '@/utils/getCloudflareMediaUrl';

const style = StyleSheet.create({
  background: {
    flex: 1,
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: 'black',
  },
  image: {
    width: '100%',
    height: '100%',
  },
});

export const EventBannerBackgroundFragment = graphql(/* GraphQL */ `
  fragment EventBannerBackground on event_team {
    team {
      id
      avatar_id
      home_primary_color
    }
  }
`);

export default function EventBannerBackground({
  fragment,
}: {
  fragment: FragmentOf<typeof EventBannerBackgroundFragment> | undefined;
}) {
  const item = readFragment(EventBannerBackgroundFragment, fragment);
  const avatarId = item?.team.avatar_id;

  return (
    <Box
      style={[
        style.background,
        {
          backgroundColor: item?.team.home_primary_color || 'black',
        },
      ]}
    >
      {avatarId ? (
        <Image
          key={avatarId}
          contentFit="cover"
          style={style.image}
          source={getCloudflareMediaUrl({
            id: avatarId,
            variant: ImageVariant.Large3x,
            // TODO get pixel density ratio
          })}
        />
      ) : null}
    </Box>
  );
}
